// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles__footer___3Kc9E","done":"styles__done___2fpDz"};